// online_internship_site/src/pages/Programs.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/programs.module.css';
import { BiTime, BiMoney } from 'react-icons/bi';

function Programs() {
  const programs = [
    {
      id: 1,
      title: 'Front-End Development',
      description:
        'Master HTML, CSS, JavaScript, React and modern front-end frameworks to build responsive web applications.',
      duration: '45 days',
      active: true,
      price: '₹1399',
      image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?w=800',
    },
    {
      id: 2,
      title: 'Backend Development',
      description:
        'Learn Node.js, Express.Js, databases, API development, and server-side architecture.',
      duration: '45 days',
      active: true,
      price: '₹1599',
      image: 'https://images.unsplash.com/photo-1623479322729-28b25c16b011?w=800', // Server architecture
    },
    {
      id: 3,
      title: 'Full Stack Development (JS)',
      description:
        'Comprehensive training in both frontend and backend technologies using JavaScript ecosystem.',
      duration: '2 months',
      active: true,
      price: '₹1799',
      image: 'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?w=800', // Multiple screens setup
    },
    {
      id: 4,
      title: 'UI/UX Design',
      description: 'Design stunning user interfaces and user experiences.',
      duration: '3 months',
      active: false,
      price: '₹450',
      image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800', // Design workspace
    },
    {
      id: 5,
      title: 'Cloud Computing',
      description: 'Gain expertise in cloud platforms and infrastructure.',
      duration: '4 months',
      active: false,
      price: '₹700',
      image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800', // Cloud servers
    },
    {
      id: 6,
      title: 'Cyber Security',
      description: 'Learn how to protect systems and networks from cyber threats.',
      active: false,
      duration: '3 months',
      price: '₹650',
      image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800', // Security concept
    },
  ];

  const handleNotify = programTitle => {
    // You can implement your notification logic here
    alert(`You will be notified when ${programTitle} becomes available!`);
  };

  return (
    <div className={styles.programsContainer}>
      <header className={styles.header}>
        <h1 className={styles.title}>Professional Career Programs</h1>
        <p className={styles.subtitle}>
          Launch your tech career with our industry-aligned programs designed by experts
        </p>
      </header>

      <div className={styles.programsGrid}>
        {programs.map(program => (
          <div
            key={program.id}
            className={`${styles.cardWrapper} ${!program.active ? styles.inactiveCard : ''}`}
          >
            {!program.active && <div className={styles.comingSoonBanner}>Coming Soon</div>}
            <div className={styles.card}>
              <img src={program.image} alt={program.title} className={styles.cardImage} />
              <div className={styles.cardContent}>
                <h2 className={styles.cardTitle}>{program.title}</h2>
                <p className={styles.cardDescription}>{program.description}</p>
                <div className={styles.cardMeta}>
                  <span>
                    <BiTime className={styles.metaIcon} />
                    {program.duration}
                  </span>
                  <span>
                    <BiMoney className={styles.metaIcon} />
                    {program.price}
                  </span>
                </div>
                {program.active ? (
                  <Link to={`/program/${program.id}`} className={styles.button}>
                    View Program Details
                  </Link>
                ) : (
                  <button
                    className={styles.notifyButton}
                    onClick={() => handleNotify(program.title)}
                  >
                    Notify Me
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Programs;
